export function normalizeLinkedInCompanyId(value) {
  return String(value || '').trim();
}

export function getLinkedInCompanyId(company = {}) {
  return normalizeLinkedInCompanyId(
    company.li_id ||
    company.linkedinCompanyId ||
    company.linkedin_company_id ||
    company.linkedinCompanyPageId ||
    company.linkedin_company_page_id ||
    company.linkedin?.companyId ||
    company.linkedin?.company_id ||
    company.integrations?.linkedin?.companyId ||
    company.integrations?.linkedin?.company_id ||
    ''
  );
}

// LinkedIn stores a numeric company ID, not a public page slug.
export function parseLinkedInCompanyId(value) {
  const input = String(value || '').trim();
  if (/^\d+$/.test(input)) return input;
  try {
    const url = new URL(/^https?:\/\//i.test(input) ? input : `https://${input}`);
    if (!['https:', 'http:'].includes(url.protocol) || !/(^|\.)linkedin\.com$/i.test(url.hostname)) return '';
    return url.pathname.match(/^\/company\/(\d+)(?:\/|$)/)?.[1] || '';
  } catch {
    return '';
  }
}
